
import img from "../../assets/profile-img.jpg";
const About = ()=>{

    return(
        <section className="about" id="about">
            <h3>About Me : </h3>
            <p className="p-4">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur dapibus ipsum est, at sagittis massa consequat ac. Duis id accumsan ante, a laoreet lectus. Fusce vel ante ut odio viverra tempor quis ac ipsum. Sed eget diam sit amet nibh cursus mattis hendrerit vitae metus. Ut vel nulla vitae lacus iaculis cursus. Fusce id sapien vehicula, ultricies massa in, egestas elit. Praesent dapibus enim quis posuere vehicula. Donec
            </p>

            <div className="row row-cols-1 row-cols-sm-2 offset-2 offset-sm-0">
                <div className="col">
                    <img src={img} alt="" className="img img-fluid m-3" />
                </div>
                <div className="col">
                <p className="p-4">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur dapibus ipsum est, at sagittis massa consequat ac. Duis id accumsan ante, a laoreet lectus. Fusce vel ante ut odio viverra tempor quis ac ipsum. Sed eget diam sit amet nibh cursus mattis hendrerit vitae metus. Ut vel nulla vitae lacus iaculis cursus. Fusce id sapien vehicula, ultricies massa in, egestas elit. Praesent dapibus enim quis posuere vehicula. Donec
            </p>
                </div>
            </div>
        </section>
    );
}

export default About;